export enum STATS_TASK_STATUS {
    DONE = 'done',
    PROGRESS = 'in_progress',
    PENDING = 'pending',
}
